export const ALREADY_PART_OF_PROJECT = 'alreadyPartOfProject'
export const NOT_PART_OF_PROJECT = 'notPartOfProject'
export const DIFF_ST_NAME = 'diffStName'
export const DIFF_LANDUSE = 'diffLandUse'
export const ADD_FEATURE_TO_PROJECT = 'Add Feature to Project'
export const REMOVE_FEATURE_FROM_PROJECT = 'Remove Feature from Project'
export const DIFF_TIERS = 'diffTiers'
